angular.module('leanlaw').directive('llOverviewReports', ['filterService', function (filterService) {
  return {
    restrict: 'EA',
    template: require("./views/overviewReports.html"),
    scope: {
      client: "=",
      matter: "=",
      me: "="
    },
    controller: ['$scope', '$state', function ($scope, $state) {
      $scope.vm = {
        period: undefined
      };
      activate();
      function activate() {
        $scope.$watchGroup(['client', 'matter'], () => {
          const {
            client,
            matter
          } = $scope;
          if (matter) {
            loadReportLinks({
              matterId: matter.id,
              returnLabel: matter.label
            });
          } else if (client) {
            loadReportLinks({
              clientId: client.id,
              returnLabel: client.label
            });
          }
        }, true);
      }
      $scope.vm.dateRangeOptions = filterService.dateRangeOptions;
      function loadReportLinks(options) {
        $scope.goToReports = (reports, dateRangeId) => {
          $state.go(reports, {
            ...options,
            dateRangeId,
            returnRoute: $state.current.name,
            returnParams: $state.params
          });
        };
      }
    }]
  };
}]);